// Core
import React from 'react';

// Theme
import { CHART_COLORS } from './theme';

const CustomizedAxisTick = ({
    x,
    y,
    payload = { value: '' },
    dy = 16,
    textAnchor = 'end',
    fill = CHART_COLORS.text,
    transform = 'rotate(-35)',
    style = { fontSize: '11px' },
}) => (
    <g transform={`translate(${x},${y})`}>
        <text
            x={0}
            y={0}
            dy={dy}
            textAnchor={textAnchor}
            fill={fill}
            transform={transform}
            style={style}
        >
            {payload.value}
        </text>
    </g>
);

export default CustomizedAxisTick;
